import useStore from '../store/useStore'
import { UnitSystem } from '../types/FirestoreUser'

export default () => {
  const unitSystem: UnitSystem =
    useStore(state => state.firestoreUser?.unitSystem) || 'imperial'
  return unitSystem
}
